// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2hCdB","approved":"Status_approved__FohmU","rejected":"Status_rejected__1vqPU","expired":"Status_expired__1d1pc","label":"Status_label__2fs54"};